
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anuncie",
      function () {
        return require("private-next-pages/anuncie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anuncie"])
      });
    }
  